/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const competitionSlideDtoSchema = z.object({
  caption: z.optional(z.string()),
  paragraphs: z.optional(z.array(z.string())),
  pageNumber: z.optional(z.int()),
});
